import SearchableCountrySelect from "../../../components/SearchableCountrySelect";
import { useRegister } from "../RegisterContext";
import { useTranslation } from "react-i18next";


const STATUSES = [

  "lawyerStatus.fifaAgent",
  "lawyerStatus.faAgent",
  "lawyerStatus.fffAgent",
  "lawyerStatus.frmfAgent",
  "lawyerStatus.figcAgent",
  "lawyerStatus.rfefAgent",

  "lawyerStatus.matchAgent",
  "lawyerStatus.sportsIntermediary",

  "lawyerStatus.sportsLawyer",
  "lawyerStatus.sportsJurist",
  "lawyerStatus.legalAdvisor",

  "lawyerStatus.independentRecruiter",
  "lawyerStatus.sportsManager",
  "lawyerStatus.sportsConsultant"

];

export default function LawyerForm() {
  const {
    handleChange,
    handleDetailsChange,
    formData,
    fieldErrors,
    details,
    setDetails,
    PHONE_RULES,
    passwordStrength,
    countries
  } = useRegister();

  const selectedStatuses = details.statuses || [];

  const { t } = useTranslation();

  const getCountryTranslation = (country) => {

    return t(
      `athleteForm.${country.toLowerCase()}`
    );

  };

  const toggleStatus = (status) => {
    const exists = selectedStatuses.includes(status);

    if (exists) {
      setDetails((prev) => ({
        ...prev,
        statuses: selectedStatuses.filter(
          (s) => s !== status
        ),
      }));
      return;
    }

    if (selectedStatuses.length >= 3) return;

    setDetails((prev) => ({
      ...prev,
      statuses: [...selectedStatuses, status],
    }));
  };

  return (
    <form
      id="register-step-form"
      className="register-form-grid"
    >
      <div className="input-wrapper">
        <label className="register-date-label" htmlFor="lawyer-birthdate">
          {t("athleteForm.birthdate")}
        </label>
        <input
          id="lawyer-birthdate"
          required
          className={`register-inputs ${fieldErrors.username ? "input-error" : ""
            }`}
          name="username"
          value={formData.username || ""}
          placeholder={t("athleteForm.username")}
          onChange={handleChange}
        />

        {fieldErrors.username && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.username}
          </div>
        )}
      </div>

      <input
        required
        className="register-inputs"
        name="lastname"
        value={formData.lastname || ""}
        placeholder={t("athleteForm.lastname")}
        onChange={handleChange}
      />

      <input
        required
        className="register-inputs"
        name="firstname"
        value={formData.firstname || ""}
        placeholder={t("athleteForm.firstname")}
        onChange={handleChange}
      />

      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.email ? "input-error" : ""
            }`}
          name="email"
          type="email"
          autoComplete="new-email"
          value={formData.email || ""}
          placeholder={t("athleteForm.email")}
          onChange={handleChange}
        />

        {fieldErrors.email && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.email}
          </div>
        )}
      </div>

      <div className="input-wrapper">
        <input
          className={`register-inputs ${fieldErrors.password
            ? "input-error"
            : passwordStrength.valid
              ? "input-success"
              : ""
            }`}
          type="password"
          name="password"
          autoComplete="new-password"
          placeholder={t("athleteForm.password")}
          value={formData.password || ""}
          onChange={handleChange}
        />

        {formData.password && (
          <>
            <div className="password-strength-bar">
              <span
                style={{
                  width: `${passwordStrength.score * 20}%`,
                }}
                className={
                  passwordStrength.score <= 2
                    ? "weak"
                    : passwordStrength.score <= 4
                      ? "medium"
                      : "strong"
                }
              />
            </div>

            <small className="password-message">
              {passwordStrength.message}
            </small>
          </>
        )}
      </div>

      <div className="input-wrapper">
        <input
          required
          className="register-inputs"
          name="birthdate"
          value={formData.birthdate || ""}
          type="date"
          onChange={handleChange}
        />

        {fieldErrors.birthdate && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.birthdate}
          </div>
        )}
      </div>

      <input
        required
        className="register-inputs"
        name="address"
        value={formData.address || ""}
        placeholder={t("athleteForm.address")}
        onChange={handleChange}
      />

      <input
        required
        className="register-inputs"
        name="postal_code"
        value={formData.postal_code || ""}
        placeholder={t("athleteForm.postalCode")}
        onChange={handleChange}
      />

      <select
        required
        className="register-select"
        name="sport"
        value={details.sport || ""}
        onChange={handleDetailsChange}
      >
        <option value="">{t("athleteForm.sport")}</option>
        <option value="Football">
          {t("athleteForm.football")}
        </option>

        <option disabled style={{ color: "#999" }}>
          {t("athleteForm.basketSoon")}
        </option>

        <option disabled style={{ color: "#999" }}>
          {t("athleteForm.handballSoon")}
        </option>
      </select>

      <SearchableCountrySelect
        required
        className="register-select"
        name="country"
        value={formData.country || ""}
        onChange={handleChange}
      >
        <option value="">{t("athleteForm.country")}</option>
        {countries.map((country) => (
          <option
            key={country.code}
            value={country.name}
          >
            {country.flag} {country.name}
          </option>
        ))}
      </SearchableCountrySelect>

      <select
        required
        className="register-select"
        name="language"
        value={formData.language}
        onChange={handleChange}
      >

        <option value="">
          {t("athleteForm.language")}
        </option>

        <option value="fr">
          🇫🇷 Français
        </option>

        <option value="en">
          🇬🇧 English
        </option>

        <option value="ar">
          🇲🇦 العربية
        </option>

        <option value="es">
          🇪🇸 Español
        </option>
        <option value="pt">🇵🇹 Português</option>
        <option value="zh">🇨🇳 中文（简体）</option>
        <option value="de">🇩🇪 Deutsch</option>
        <option value="ru">🇷🇺 Русский</option>
        <option value="it">🇮🇹 Italiano</option>
        <option value="sr">🇷🇸 Srpski</option>

      </select>

      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.phone ? "input-error" : ""
            }`}
          name="phone"
          value={formData.phone || ""}
          placeholder={
            PHONE_RULES[formData.country]?.placeholder ||
            t("athleteForm.phone")
          }
          onChange={handleChange}
        />

        {fieldErrors.phone && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.phone}
          </div>
        )}
      </div>

      <div className="multi-status-block">
        <label className="multi-status-title">
          {t("lawyerForm.specialities")}
        </label>

        <div className="status-chip-grid">
          {STATUSES.map((status) => {
            const active =
              selectedStatuses.includes(status);

            const disabled =
              !active &&
              selectedStatuses.length >= 3;

            return (
              <button
                type="button"
                key={status}
                disabled={disabled}
                onClick={() => toggleStatus(status)}
                className={`status-chip ${active ? "active" : ""
                  }`}
              >
                {t(status)}
              </button>
            );
          })}
        </div>
        {selectedStatuses.length === 0 && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {t("lawyerForm.specialityRequired")}
          </div>
        )}
      </div>
    </form>
  );
}
